import { useTranslation } from 'react-i18next';

export default function ConfirmationModal({
  isOpen,
  onClose,
  onAccept,
}) {
  if (!isOpen) return null;
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-lg relative border border-default">
        <h3 className="text-center text-xl mb-4 font-bold m-6 pb-6 border-b border-default text-gray-900 dark:text-white">{ t('confirmations.confirm') }</h3>
        <button onClick={onClose} type="button" className="absolute top-5 right-5 text-gray-500 dark:text-gray-300 bg-transparent hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white rounded-base text-sm w-9 h-9 ms-auto inline-flex justify-center items-center" data-modal-hide="popup-modal">
          <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6"/></svg>
        </button>
        <p className="text-gray-800 dark:text-white pr-6 pl-6 whitespace-pre-line text-center">
          {t('confirmations.deleteInputField')}
        </p>

        <div className="flex justify-center gap-3 border-t border-default m-6 pt-6">
          <button
            onClick={onAccept}
            className="px-4 py-2 bg-red-600 rounded-xl text-white rounded hover:bg-red-700"
          >
            {t('confirmations.delete')}
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-xl hover:bg-gray-400 dark:hover:bg-gray-600"
          >
            {t('confirmations.closeModal')}
          </button>
        </div>
      </div>
    </div>
  );
}